export const GROUP_ADMINS = 1;
export const GROUP_LAN_SUPPORT = 3;
export const GROUP_OPS_SUPPORT = 4;
export const GROUP_PRINTERS = 6;
export const GROUP_ASCOM = 7;
export const GROUP_DEVICES = 8;
export const GROUP_VELTI = 9;
export const GROUP_SRT_SUPPORT = 10;
export const GROUP_CALL_OPERATOR = 11;
